import { gql } from "@apollo/client";

const MEMBER_BY_ID = gql`
  query leagueMember(
    $id: Int!
    $userId: Int
    $leagueId: Int
    $userPublicId: String
    $leaguePublicId: String
  ) {
    leagueMember(
      id: $id
      userId: $userId
      leagueId: $leagueId
      userPublicId: $userPublicId
      leaguePublicId: $leaguePublicId
    ) {
      id
      member {
        name
        surname
        email
        phone
        nation
        gender
        city
        street
        user_club_text
        role
        password
        dob
        id
        publicId
        avatar
      }
      role {
        id
        role {
          id
          name
        }
      }
      organizationName
      organizationEmail
      organizationPhone
      organizationLogo
      isOrganization
      displayMember
    }
  }
`;

export default MEMBER_BY_ID;
